import styles from './styles.css';
import FormControls from './../components/formControls';

import Account from './account';
import AppNotificationClick from './appNotificationClick';
import OutsideApp from './outsideApp';
import Panels from './panels';
import ApiTestPageModule from './apiTest'

// Module
import routes from './routes';

export default angular.module( 'app.main.module',
    [
	    Account,
	    Panels,
	    AppNotificationClick,
	    OutsideApp,
	    ApiTestPageModule,
		FormControls

    ] )
    .config(routes)
    .name;




/** WEBPACK FOOTER **
 ** ./src/main/index.js
 **/